import { FC } from 'react';
import Link from 'next/link';

import { i18n as I18n } from 'utils/i18n';
import Spinner from '../shared/spinner';

interface Props {
  label?: string;
  disabled?: boolean;
  component?: string | FC;
  conflictComponent?: FC;
  conflict?: boolean;
  onClick?: (object) => any;
  loading?: boolean;
}

const AddToBasketConflict: FC = () => {
  return (
    <div className="quick-book__clash-alert">
      <p className="quick-book__clash-alert-text">
        {I18n.t('quick_book.timeslot_widget.conflict_warning')}
      </p>
      <Link href={I18n.t('navigation.advanced_booking.url')}>
        <a
          data-testid="advancedBookingLink"
          className="button button--secondary button--block"
        >
          {I18n.t('quick_book.go_to_advanced_booking')}
        </a>
      </Link>
    </div>
  );
};

const AddToBasketButton: FC<Props> = ({
  children,
  label = I18n.t('shared.add_to_basket'),
  disabled = false,
  component: Component = 'button',
  conflictComponent: Conflict = AddToBasketConflict,
  conflict = false,
  loading = false,
  onClick = () => {},
  ...props
}) => {
  const addToBasket = event => {
    event.preventDefault();

    return Promise.resolve(onClick()).catch(() =>
      // unhappy path not catered for in this story
      // eslint-disable-next-line
      alert('Temporary popup to say there was an issue saving the booking')
    );
  };

  return conflict ? (
    <Conflict />
  ) : (
    <Component
      className="button button--secondary button--block"
      onMouseDown={event => event.preventDefault()}
      {...props}
      disabled={disabled}
      onClick={addToBasket}
    >
      {loading && <Spinner className="button__spinner" />}
      {children || label}
    </Component>
  );
};

export default AddToBasketButton;
